export const filter = {
  id : null,  
  name: '', 
  created_at: '',
  updated_at: ''  
};
